<template>
  <div class="select_dialog_embed">
    <div class="channel_inventory_enquiry_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--导出库存确认-->
          <div class="select_dialog_embed_box_handle">
            请确定是否要将查询的库存导出到EXCEL？
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb20">
          <button class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>
    </div>
  </div>
</template>

<script type="es6">
  import MsgDialog from '../../public-component/msg-dialog';

    export default {
        name: 'channel-inventory-enquiry-embed-msg',
      /**
       *  title：  头部名
       *  showType:
       *  params: 导出的传入参数
       *  exportInventoryMsg: 导出的成本价信息
       * */
      props: ['title', 'showType', 'params', 'exportInventoryMsg'],
      components: {MsgDialog},
      data() {
        return {
          isMsg: false, // 信息框显示
          isSuc: false, // 是否成功
          txtMsg: '', // 信息框内容
          time: 3, // 倒计时时间
          timer: null // 计时器
        }
      },
      methods: {
        // 渠道库存导出
        exportStoreroomStockData() {
          this.$axios.post(this.Global.exportStoreroomStockData, this.params).then((res) => {
            console.log(res);
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
              window.open(res.data.resData, '_blank');
            } else {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = res.data.errorMsg;
            }
          });
        },

        // 提交按钮
        submitBtn() {
          this.exportStoreroomStockData();

          // 计时器
          if (this.isMsg) {
            this.time = 3;
            const self = this;
            this.timer = setInterval(function () {
              self.time = --self.time;
              if (self.time < 1) {
                self.isMsg = false;
                clearInterval(self.timer);
              }
            }, 1000);
          }
        },

        // 取消按钮
        cancelBtn(type) {
          this.$emit('cancelbtn', {isShow: false, handleType: type});
        },

        // 接收提示框传送的数据
        closeMsgDialog(e) {
          this.isMsg = e;
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/channel-inventory-enquiry-embed-msg.vue